export const ERROR_MESSAGE_NOTIFICATION = "common.notify-error" as const;
